import React, {Component, PureComponent} from 'react';

import {List, WingBlank, InputItem, Button, Toast} from 'antd-mobile';
import {Icon} from 'antd';
import PublicHeader from './../../components/header/index';
import history from '../../utils/history';

import {connect} from 'react-redux';
import {createForm} from 'rc-form';
import {userRecharge} from './store/actionCreators';

const isIPhone = new RegExp('\\biPhone\\b|\\biPod\\b', 'i').test(window.navigator.userAgent);
let moneyKeyboardWrapProps;
if (isIPhone) {
    moneyKeyboardWrapProps = {
        onTouchStart: e => e.preventDefault(),
    };
}


class Recharge extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            type: 'money',
        }
        this.bindEvent();
    }

    bindEvent() {
        this.recharge = this.recharge.bind(this);
    }

    async recharge() {
        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }
        let amount = this.inputRef.state.value;

        if (!amount || amount <= 0) {
            Toast.info("请输入充值金额！")
            return;
        }
        let data = {
            amount: amount,
        }
        if (amount < 1000) {
            Toast.info("充值金额最小为1000，请重新输入金额！")
            return;
        }

        Toast.loading('充值中...', 5, () => {
            history.replace('/myCharge');
        });
        const result = await this.props.userRecharge(data);

        console.log("pay result:", result)
        if (result.status === 200 && result.data.result) {
            window.WeChatPay.Base.getInstance().WeChatPay(result.data.result, this.HandlePayCallBack);
        } else {
            Toast.info("充值失败!请联系客服。");
            //history.replace('/myCharge');
        }
        Toast.hide();
    }

    HandlePayCallBack(res) {
        if (res.err_msg === "get_brand_wcpay_request:ok") {
            Toast.success('充值成功');
            history.replace('/myCharge');
        }
        else {
            history.replace('/myCharge');
            Toast.success('充值失败!');
        }
    }

    render() {
        const {getFieldProps} = this.props.form;
        const {type} = this.state;

        return (
            <div>
                <PublicHeader title="会员充值"/>
                <WingBlank size="md">
                    <List style={{marginTop: "30px", background: "#FFF"}}>
                        <InputItem
                            {...getFieldProps('money2', {
                                normalize: (v, prev) => {
                                    if (v && !/^(([1-9]\d*)|0)(\.\d{0,2}?)?$/.test(v)) {
                                        if (v === '.') {
                                            return '0.';
                                        }
                                        return prev;
                                    }
                                    return v;
                                },
                            })}
                            type={type}
                            placeholder="请输入金额"
                            ref={el => this.inputRef = el}
                            defaultValue={1000}
                            clear
                            moneyKeyboardWrapProps={moneyKeyboardWrapProps}
                        >充值金额</InputItem>
                    </List>

                    <Button style={{
                        backgroundColor: "#FD9D24",
                        color: "#FFFFFF",
                        margin: "60px 80px 20px 80px",
                        height: "40px",
                        lineHeight: "40px"
                    }}
                            onClick={this.recharge}>立即充值</Button>
                    <div style={{color: '#888', textAlign: "center", margin: "0 20px"}}>
                        特别说明：按照场馆规定，充值金额1000元起，若有疑问，请联系对应场馆客服。
                    </div>
                </WingBlank>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    userRecharge: (data) => dispatch(userRecharge({
        amount: data.amount,
    })),
});
const RechargeWapperForm = createForm()(Recharge);
export default connect(null, mapDispatchToProps)(RechargeWapperForm);

